import React from "react";
import { AlertTriangle } from "lucide-react";

export const Disclaimer = () => (
  <div
    data-testid="disclaimer-banner"
    className="border-grid surface px-4 py-2 flex items-center gap-2 text-xs"
    style={{ color: "var(--warn)" }}
  >
    <AlertTriangle size={14} />
    <span className="text-muted-2">
      <span className="font-semibold" style={{ color: "var(--warn)" }}>
        Disclaimer:
      </span>{" "}
      Educational purposes only. Not financial advice. Trading involves
      substantial risk. Consult a SEBI-registered advisor before investing.
    </span>
  </div>
);
